<div class="table-container">
  <app-list-header
    [title]="title"
    [searchPlaceholder]="'status.search' | translate"
    [searchTerm]="searchTerm | async"
    (searchTermChange)="searchTerm.next($event); searchStatus()"
    (clearSearch)="clearFilter()"
    (addNewItem)="createStatus()"
  ></app-list-header>
  <table class="table">
    <thead>
      <tr>
        <th class="name-header"></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let status of filteredStatus | async"
        (click)="select(status)"
        [class.selected]="status === selectedStatus"
      >
        <td>{{ status.name }}</td>
        <td>
          <span
            [style.background-color]="'#FF6347'"
            mat-icon-button
            class="reduced"
          >
            <mat-icon [style.color]="status.color">check_circle</mat-icon>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
